/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type importSageIntacctExpenseItemModal_viewer$ref: FragmentReference;
declare export opaque type importSageIntacctExpenseItemModal_viewer$fragmentType: importSageIntacctExpenseItemModal_viewer$ref;
export type importSageIntacctExpenseItemModal_viewer = {|
  +id: string,
  +actualPersonId: ?string,
  +$refType: importSageIntacctExpenseItemModal_viewer$ref,
|};
export type importSageIntacctExpenseItemModal_viewer$data = importSageIntacctExpenseItemModal_viewer;
export type importSageIntacctExpenseItemModal_viewer$key = {
  +$data?: importSageIntacctExpenseItemModal_viewer$data,
  +$fragmentRefs: importSageIntacctExpenseItemModal_viewer$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "importSageIntacctExpenseItemModal_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actualPersonId",
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
// prettier-ignore
(node/*: any*/).hash = '2c006bbf80244123db7e251250f259a1';

module.exports = node;
